<template>
  <div class="app-container">
    <el-form v-model="queryForm" :inline="true" class="query-form">
      <el-form-item>
        <el-input v-model="queryForm.title" clearable type="text" placeholder="请输入关键字查询" />
      </el-form-item>
      <el-button type="primary" @click="handleSearch">
        <i class="el-icon-search" />查询
      </el-button>
      <el-button type="default" @click="resetSearch">
        <i class="el-icon-refresh" />重置刷新
      </el-button>
    </el-form>
    <el-divider class="query-form-divider" />
    <div class="query-button-wrap">
      <el-button type="success" @click="handleCreateNew" class="margin-bottom-20">
        <i class="el-icon-plus" />新建
      </el-button>
    </div>

    <el-table v-loading="table.listLoading" :data="table.items" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort">
      <!-- <el-table-column label="id" width="80" prop="id" sortable></el-table-column> -->
      <el-table-column label="问卷标题" prop="title"></el-table-column>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status==1" type="success">已开放</el-tag>
          <el-tag v-else-if="scope.row.status == 0" type="info">已关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="handleTopicEdit(scope.$index, scope.row)">问卷内容</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" @click="handleViewStatistics(scope.row)">问卷统计</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page.sync="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.pagesize" layout="total,jumper,prev, pager, next,sizes" :total="table.totalCount" @size-change="handleSizeChange" @current-change="current_change" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="form.show" :close-on-click-modal="false" width="400px">
      <el-form ref="dataForm" :rules="form.rules" :model="form.data" label-position="top">
        <el-form-item label="问卷标题" prop="title">
          <el-input v-model="form.data.title" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <!-- <el-select @change="select_status" class="width-100" v-model="form.data.status" clearable placeholder="请选择状态">
            <el-option v-for="item in status" :key="item.value" :label="item.text" :value="item.value" />
          </el-select> -->

          <el-switch v-model="switchStatus" on-color="#00A854" on-text="启用" on-value="1" off-color="#F04134" off-text="关闭" off-value="0" @change="changeSwitch()">
          </el-switch>
          <!-- <el-input v-model="form.data.status" /> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="default" @click="form.show = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?handleSave():handleSave()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const defaultData = {
  id: 0
};

const controller = "question";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      status: [
        {
          text: "开启",
          value: 1
        },
        {
          text: "关闭",
          value: 0
        }
      ],
      table: {
        items: [],
        listLoading: true,
        pagesize: 20,
        page: 1,
        totalCount: 0,
        sorting: "id desc"
      },
      dialogStatus: "",
      queryForm: {
        title: ""
      },
      form: {
        show: false,
        submitting: false,
        data: {
          ...defaultData
        },
        rules: {
          title: [
            {
              required: true,
              message: "请输入问卷标题",
              trigger: "blur"
            }
          ],
          status: [
            {
              required: true,
              message: "请选择状态",
              trigger: "blur"
            }
          ]
        }
      },
      textMap: {
        update: "编辑",
        create: "新建"
      },
      switchStatus: true
    };
  },
  created() {
    this.fetchData(); // 如果开启了默认排序,不需要这一行
  },
  methods: {
    fetchData() {
      this.table.listLoading = true;
      this.$abpApi[controller]
        .getAll({
          skipCount: (this.table.page - 1) * this.table.pagesize,
          sorting: this.table.sorting,
          maxResultCount: this.table.pagesize,
          title: this.queryForm.title
        })
        .then(response => {
          this.table.items = response.data.items;
          this.table.totalCount = response.data.totalCount;
          this.table.listLoading = false;
        });
    },
    // 切换切面,在watch中监听 page
    current_change(e) {
      this.table.page = e;
    },
    // 排序
    sort(e) {
      console.log("sort : ", e);
      if (e.prop && e.order) {
        this.table.sorting = `${e.prop} ${e.order}`;
      } else {
        this.table.sorting = "id descending";
      }
      this.fetchData(1);
    },
    handleSizeChange(e) {
      this.table.pagesize = e;
      this.fetchData();
    },
    handleSearch() {
      this.fetchData();
    },
    handleCreateNew() {
      this.resetForm();
      this.dialogStatus = "create";
      this.form.show = true;
      this.$abpApi[controller]
        .getForEdit({
          id: 0
        })
        .then(res => {
          this.form.data = res.data.data;
          this.form.data.status = 1;
          this.switchStatus = true;
        });
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleEdit($index, $row) {
      this.resetForm();
      const { id } = $row;
      this.$abpApi[controller]
        .getForEdit({
          id
        })
        .then(res => {
          this.form.data = res.data.data;
          this.dialogStatus = "update";
          this.form.show = true;
          if (this.form.data.status == 1) {
            this.switchStatus = true;
          } else {
            this.switchStatus = false;
          }
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        });
    },
    handleSave() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          console.log(this.form.data);
          let fn;
          if (this.form.data.id) {
            fn = this.$abpApi[controller].update;
          } else {
            fn = this.$abpApi[controller].create;
          }
          fn(this.form.data).then(res => {
            this.form.submitting = false;
            this.form.show = false;
            this.fetchData();
          });
        }
      });
    },
    handleDelete($index, $row) {
      const { id } = $row;
      this.$confirm("您确认要删除吗", "删除提示").then(() => {
        this.$abpApi[controller]
          .delete({
            id
          })
          .then(res => {
            console.log("delete then");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.fetchData();
          });
      });
    },
    handleViewStatistics($row){
      this.$router.push({
        name:'question-statistics',
        params:{id:$row.id}
      });
    },

    handleTopicEdit($index, $row) {
      var that = this;
      const id = $row.id;
      this.$router.push({
        name: "questionTopicEdit",
        params: {
          id: id
        }
      });
    },
    resetForm() {
      this.form = Object.assign({}, this.form, {
        data: {
          ...defaultData
        }
      });
    },
    resetSearch() {
      this.queryForm = {
        title: ""
      };
      this.fetchData();
    },
    // 图片上传前判断
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 上传成功后回调
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.success) {
        //这里写回调逻辑
        // this.form.data.titleImagePath = res.result
      }
    },
    select_status(val) {
      this.$forceUpdate();
    },
    changeSwitch() {
      if (this.switchStatus == true) {
        this.form.data.status = 1;
      } else {
        this.form.data.status = 0;
      }
      console.log("22222:" + this.form.data.status);
    }
  }
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
}

.avatar {
  width: 88px;
  height: 88px;
  display: block;
}
</style>
